var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#6234e8}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9,19.9C56.9,19.8,56.9,19.8,56.9,19.9c-3.7-1.7-7.5-2.9-11.4-3.6c-0.1,0-0.1,0-0.2,0.1 c-0.5,0.9-1,1.9-1.4,2.9c-4.2-0.6-8.5-0.6-12.7,0c-0.4-1-0.9-2-1.4-2.9c0-0.1-0.1-0.1-0.2-0.1c-3.9,0.7-7.7,1.9-11.3,3.5 c0,0-0.1,0-0.1,0.1c-7.2,10.8-9.2,21.3-8.2,31.7c0,0.1,0,0.1,0.1,0.1c4.2,3.1,8.9,5.5,13.9,7c0.1,0,0.2,0,0.2-0.1 c1.1-1.5,2-3,2.8-4.6c0-0.1,0-0.2-0.1-0.2c0,0,0,0,0,0c-1.5-0.6-3-1.3-4.3-2.1c-0.1-0.1-0.1-0.2-0.1-0.2c0,0,0,0,0-0.1 c0.3-0.2,0.6-0.4,0.9-0.7c0.1,0,0.1-0.1,0.2,0c9.1,4.2,19,4.2,28,0c0.1,0,0.1,0,0.2,0c0.3,0.2,0.6,0.5,0.9,0.7 c0.1,0.1,0.1,0.2,0,0.3c0,0,0,0-0.1,0c-1.4,0.8-2.8,1.5-4.4,2.1c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0,0,0c0.8,1.6,1.8,3.2,2.8,4.6 c0,0.1,0.1,0.1,0.2,0.1c5-1.5,9.7-3.9,13.9-7c0,0,0.1-0.1,0.1-0.1C66.3,39.5,63.2,29.1,56.9,19.9z M28.3,45.2c-2.7,0-5-2.5-5-5.6 s2.2-5.6,5-5.6c2.8,0,5.1,2.5,5,5.6C33.3,42.7,31,45.2,28.3,45.2z M46.8,45.2c-2.7,0-5-2.5-5-5.6s2.2-5.6,5-5.6c2.8,0,5.1,2.5,5,5.6 C51.8,42.7,49.6,45.2,46.8,45.2z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.68c3c812bbe26b593b883632200b1192.svg";
export { ForwardRef as ReactComponent };